(() => {
 'use strict';
 const root=document.getElementById('palmer-page');
 if(!root || root.dataset.initialized) return;
 root.dataset.initialized='true';
 const config=JSON.parse(document.getElementById('palmer-data').textContent);
 const slugify=s=>s.toLowerCase().replace(/\+/g,' ').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
 const variants=config.variants.map(v=>({...v,id:String(v.id),slug:slugify(v.title)}));
 const all=s=>[...root.querySelectorAll(s)], one=s=>root.querySelector(s);
 const money=c=>new Intl.NumberFormat(config.locale||'en-US',{style:'currency',currency:config.currency||'USD',maximumFractionDigits:2}).format(c/100);
 let selected, busy=false, galleryIndex=0;
 const media=v=>config.photos[v.slug]||[];
 const fallback=()=>variants.find(v=>v.slug==='black'&&v.available)||variants.find(v=>v.available&&v.slug!=='canary')||variants.find(v=>v.available)||variants.find(v=>v.slug==='black')||variants[0];
 function fromURL(){const p=new URL(location.href).searchParams;return variants.find(v=>v.id===p.get('variant'))||variants.find(v=>v.slug===p.get('color'))||fallback();}
 function image(el,m){
  el.hidden=!m;
  if(!m){el.removeAttribute('src');el.removeAttribute('srcset');return;}
  el.src=config.localAssets?m.local:m.src;
  el.alt=`The Palmer in ${selected.title} — ${m.caption}`;
  el.width=m.width;el.height=m.height;el.dataset.color=selected.slug;
 }
 function gallery(){
  const ms=media(selected);galleryIndex=Math.min(galleryIndex,Math.max(0,ms.length-1));
  image(one('[data-gallery-main]'),ms[galleryIndex]);
  one('[data-gallery-caption]').textContent=ms[galleryIndex]?`${selected.title} / ${ms[galleryIndex].caption}`:'';
  all('[data-gallery-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.galleryIndex)===galleryIndex)));
 }
 function buttons(){all('[data-buy]').forEach(b=>{b.disabled=!selected.available||busy;b.setAttribute('aria-disabled',String(b.disabled));b.textContent=busy?'Adding…':!selected.available?`${selected.title} — sold out`:`${selected.preorder?'Pre-order':'Add to cart'} — ${selected.title} · ${money(selected.price)}`;});all('[data-color]').forEach(b=>b.disabled=busy);}
 function render(v,historyMode='replaceState'){
  if(!v)return;selected=v;galleryIndex=0;
  root.dataset.selectedVariant=v.id;root.dataset.selectedColor=v.slug;
  all('[data-color-name]').forEach(el=>el.textContent=v.title);
  all('[data-price]').forEach(el=>el.textContent=money(v.price));
  all('[data-compare]').forEach(el=>{el.hidden=!(v.compare_at_price>v.price);el.textContent=el.hidden?'':money(v.compare_at_price);});
  all('input[name="id"]').forEach(el=>el.value=v.id);
  all('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===v.slug)));
  const stock=one('[data-stock]');stock.classList.toggle('soldout',!v.available);stock.textContent=!v.available?`${v.title} is sold out. Choose another color to see availability.`:v.preorder?`${v.title} — pre-order. Ships when restocked.`:`${v.title} — available`;
  const ms=media(v);one('[data-missing-media]').hidden=ms.length>0;
  all('[data-image-slot]').forEach(el=>{
   const slot=Number(el.dataset.imageSlot);
   const index=slot<ms.length?slot:Math.min(slot===7?5:2,ms.length-1);
   image(el,ms[index]);
   if(el.closest('.story'))el.closest('figure').querySelector('figcaption').textContent=ms[index]?`${v.title} / ${ms[index].caption}`:'';
  });
  one('.plate-number').textContent=ms.length?`01—${String(ms.length).padStart(2,'0')}`:'';
  one('[data-thumbnails]').replaceChildren(...ms.map((m,i)=>{
   const b=document.createElement('button');b.type='button';b.className='thumbnail';b.dataset.galleryIndex=i;b.setAttribute('aria-label',`View ${v.title}: ${m.caption}`);
   const img=document.createElement('img');img.dataset.productImage='';img.loading='lazy';image(img,m);b.append(img);
   b.addEventListener('click',()=>{galleryIndex=i;gallery();});return b;
  }));gallery();buttons();
  one('[data-cart-message]').textContent='';
  if(historyMode){const u=new URL(location.href);u.searchParams.set('variant',v.id);u.searchParams.set('color',v.slug);history[historyMode]({palmerVariant:v.id},'',u);}
  root.dispatchEvent(new CustomEvent('palmer:variant-change',{bubbles:true,detail:{variant:v}}));
 }
 one('[data-review]').hidden=!config.review;
 const colorHex={'black':'#222222','od-green':'#828661','cerulean':'#169cd8','canary':'#f3ad24','mulberry-deep-blue':'#a84970','buttermilk-raspberry':'#e4d2a4'};
 const order=['black','od-green','cerulean','canary','mulberry-deep-blue','buttermilk-raspberry'];
 [...variants].sort((a,b)=>order.indexOf(a.slug)-order.indexOf(b.slug)).forEach(v=>{
  const b=document.createElement('button');b.type='button';b.className='swatch'+(!v.available?' soldout':'')+(v.title.length>10?' extra':'');b.dataset.color=v.slug;b.setAttribute('aria-label',v.title+(v.available?'':' — sold out'));
  const dot=document.createElement('span');dot.className='swatch-dot';dot.style.setProperty('--swatch',colorHex[v.slug]||'#bbb');dot.setAttribute('aria-hidden','true');
  const label=document.createElement('span');label.textContent=v.title+(v.available?'':' ×');b.append(dot,label);b.addEventListener('click',()=>{if(!busy)render(v,'pushState');});one('[data-swatches]').append(b);
 });
 all('[data-cart-form]').forEach(form=>{
  form.action=(config.root||'/')+'cart/add';
  form.addEventListener('submit',async e=>{
   e.preventDefault();if(busy||!selected.available)return;
   const item={id:selected.id,quantity:1};if(selected.preorder)item.properties={'Pre-order':'Ships when restocked'};
   if(config.review){one('[data-cart-message]').textContent=`Review only: would add 1 × ${selected.title} (${selected.id}) at ${money(selected.price)}. No cart was changed.`;return;}
   busy=true;buttons();
   try{
    const response=await fetch((config.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});
    const result=await response.json();if(!response.ok)throw Error(result.description||result.message||'Could not add this color. Please try again.');
    root.dispatchEvent(new CustomEvent('palmer:cart-added',{bubbles:true,detail:{variant:selected,result}}));
    location.assign((config.root||'/')+'cart');
   }catch(error){one('[data-cart-message]').textContent=error.message||'Could not add this color. Please try again.';}
   finally{busy=false;buttons();}
  });
 });
 window.addEventListener('popstate',()=>{if(!busy)render(fromURL(),null);});
 render(fromURL());
})();
